import { ChampionshipDriver } from "api/model/Championship/ChampionshipDriver";
import { Collections } from "api/model";
import { useFirestore } from "react-redux-firebase";
import { useEffect, useState } from "react";

export const useDriversByChampById = (championshipsId: string[]) => {
    const firestore = useFirestore();
    const [driversByChampById, setDriversByChampById] = useState({});

    useEffect(() => {
        if (championshipsId) {
            const promises = championshipsId
                .filter((id) => id !== "-1")
                .map((championshipId) => {
                    return new Promise<ChampionshipDriver[]>(
                        (resolve, reject) => {
                            return firestore
                                .collection(Collections.CHAMPIONSHIP_DRIVERS)
                                .where("championshipId", "==", championshipId)
                                .get()
                                .then((snap) =>
                                    snap.docs.map<ChampionshipDriver>(
                                        (doc) =>
                                            ({
                                                ...doc.data(),
                                                id: doc.id,
                                            } as ChampionshipDriver)
                                    )
                                )
                                .then((drivers) => resolve(drivers))
                                .catch((error) => reject(error));
                        }
                    );
                });

            const driversByChampById = {};

            Promise.all(promises)
                .then((result) =>
                    result.reduce(
                        (previousValue, currentValue) => [
                            ...previousValue,
                            ...currentValue,
                        ],
                        []
                    )
                )
                .then((drivers) => {
                    if (drivers) {
                        const driversById = {};

                        championshipsId.forEach((championshipId) => {
                            drivers.forEach(
                                (driver) =>
                                    (driversById[
                                        driver.id || ""
                                    ] = `#${driver.usedNumber} - ${driver.displayName}`)
                            );
                            driversByChampById[championshipId] = driversById;
                        });

                        setDriversByChampById(driversByChampById);
                    }
                });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [championshipsId]);

    return driversByChampById;
};
